"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : COPY SNIPPET FIELD : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  copysnippetfield: {
    fontSize: (0, _index.pxToEm)(16),
    '& .codepiece': {
      color: 'rgb(6, 43, 117)',
      '& p.description': {
        height: 'auto',
        fontSize: (0, _index.pxToEm)(14),
        fontWeight: 'normal',
        lineHeight: '20px',
        marginTop: (0, _index.pxToEmWithBaseline)({
          value: 8,
          fontSizeBaseline: 14
        })
      },
      '& h3.title': {
        fontSize: (0, _index.pxToEm)(16),
        lineHeight: (0, _index.pxToEm)(24),
        fontWeight: 'bold',
        letterSpacing: 0,
        marginTop: 0,
        marginBottom: 0
      },
      '& .group': {
        '& .ctas': {
          height: (0, _index.pxToEmWithBaseline)({
            value: 48,
            fontSizeBaseline: 16
          }),
          display: 'inline-block',
          '& .copyfield.copied-false': {
            '& .cta.button': {
              width: (0, _index.pxToEm)(80)
            }
          },
          '& .cta.button': {
            fontFamily: '"Work Sans", sans-serif;',
            fontSize: (0, _index.pxToEm)(16),
            fontWeight: 500
          }
        },
        '& .field': {
          maxWidth: (0, _index.pxToEmWithBaseline)({
            value: 513,
            fontSizeBaseline: 16
          }),
          marginTop: (0, _index.pxToEmWithBaseline)({
            value: 16,
            fontSizeBaseline: 16
          }),
          marginBottom: (0, _index.pxToEmWithBaseline)({
            value: 8,
            fontSizeBaseline: 16
          }),
          display: 'block',
          '& .formelement': {
            fontWeight: 'normal',
            height: (0, _index.pxToEm)(48),
            background: 'rgb(250, 251, 252)',
            borderRadius: (0, _index.pxToEm)(4),
            border: "".concat((0, _index.pxToEm)(2), " solid rgb(238, 242, 246)"),
            padding: 0,
            '& .textfield': {
              fontSize: (0, _index.pxToEm)(14),
              overflow: 'hidden',
              padding: '16px',
              paddingTop: '12px'
            }
          }
        }
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  copysnippetfield: {
    '& .buttonlink': {
      display: 'block',
      '& .link': {
        display: 'block',
        marginTop: '8px'
      }
    }
  }
});

exports.default = _default;